import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './CallMeConfirmationModal.scss';

export default class CallMeConfirmationModal extends Component {
    static get propTypes() {
        return {
            phone: PropTypes.string
        };
    }

    componentDidMount() {
        trackEvent(
            'Request',
            !this.props.isBuyer
                ? 'phonelessSellerLandedOnContactConfirmPopupAfterMessageORCallAgent'
                : 'phonelessBuyerLandedOnContactConfirmPopupAfterMessageORCallAgent'
        );
    }

    render() {
        return (
            <div className="modal nu-modal verify-phone-modal fade" role="dialog">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header pt-4x pt-6x-sm pl-8x-sm pr-8x-sm">
                                <div className="modal-title text-center">
                                    Got it! We&apos;ll give you a call shortly.
                                </div>
                            </div>
                            <div className="modal-body pl-3x-sm pr-3x-sm">
                                <div className="message">
                                    Your UpNest advisor will call you at <span className="text-semibold text-highlight">{returnPhoneFormat(this.props.phone)}</span> to make sure we can find the right agent for you.
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-blue-gray-outline mt-4x mb-4x mb-6x-sm"
                                    data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
